import { defineStore } from "pinia";
import axios from "axios";

export const useLocationStore = defineStore("locationStore", {
  actions: {
    async states(): Promise<any> {
      const response = await axios.get(
        "https://servicodados.ibge.gov.br/api/v1/localidades/estados/"
      );
      return response.data;
    },
    async cities(stateId: number): Promise<any> {
      const response = await axios.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateId}/municipios`
      );
      return response.data;
    },
  },
});
